import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Global from '../../../../store/global-selectors';
import { ShippingStrategyDefaultTagWithName } from '../../../../components/shipping-strategy-default-tag/shipping-strategy-default-tag-with-name';
import useServiceColumnDisplay from './use-service-column-display';
import messages from '../messages';

const InternationalServiceColumn = ({ id: presetGroupId }) => {
  const serviceId = useSelector((state) =>
    Global.selectEntitiesPresetGroupPropertyById(state, {
      profileId: presetGroupId,
      property: 'intlServiceId',
    }),
  );
  const intlRateShopperGuid = useSelector((state) =>
    Global.selectEntitiesPresetGroupPropertyById(state, {
      profileId: presetGroupId,
      property: 'intlRateShopperGuid',
    }),
  );

  const { name, isTemplate } = useServiceColumnDisplay(serviceId, intlRateShopperGuid);

  if (!name) {
    return '';
  }

  return isTemplate ? <ShippingStrategyDefaultTagWithName name={name} /> : name;
};

InternationalServiceColumn.propTypes = {
  id: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: messages.internationalServiceColumn,
  name: <FormattedMessage {...messages.internationalServiceColumn} />,
  id: 'internationalService',
  isSortable: false,
  render: InternationalServiceColumn,
};
